module.exports = {
	"pagination": {
		"GetBotAliases": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"GetBotChannelAssociations": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"GetBotVersions": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"GetBots": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"GetBuiltinIntents": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"GetBuiltinSlotTypes": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"GetIntentVersions": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"GetIntents": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"GetMigrations": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"GetSlotTypeVersions": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"GetSlotTypes": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/lex-models-2017-04-19.paginators.json
// module id = 2144
// module chunks = 0